import gsap from 'gsap';
import { CanvasTexture, Color, Mesh, Object3D, PlaneGeometry } from 'three';
import { mergeBufferGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils';
import { appMixin } from '../../utils/appMixin';
import { TextMaterial } from '../Materials/Text/material';

export class Text extends appMixin(Object3D) {
  constructor(app, config) {
    super(app);

    this._config = config;
    this.canvas = document.createElement('canvas');
    this.canvas.width = this.canvas.height = 1024;
    this.ctx = this.canvas.getContext('2d');

    // document.querySelector('#content').appendChild(this.canvas);

    this.texture = new CanvasTexture(this.canvas);
    this.createMesh();
  }

  onAttach() {
    const font = new FontFace('Hyperwave', `url(${this._config.font})`);

    const $blank = document.createElement('span');
    $blank.innerHTML = '&nbsp;';
    $blank.style.fontFamily = this._config.fontName;
    $blank.style.display = 'none';
    document.body.appendChild($blank);

    const $style = document.createElement('style');
    $style.innerHTML = `@font-face {
      font-family: '${this._config.fontName}';
      src: url(${this._config.font});
      font-weight: normal;
      font-style: normal;
      font-display: swap;
  }
  `;
    document.body.appendChild($style);

    font.load().then(() => {
      setTimeout(() => {
        document.fonts.ready.then(() => {
          this.draw();
          this.open();
        });
      }, 1);
    });
  }

  update(config) {
    this._config = { ...this._config, ...config };

    this.utl?.kill();
    this.utl = gsap.timeline();

    this.utl.add(this.close());
    if (this._config.active) {
      this.utl.add(() => {
        this.draw();
      });
      this.utl.add(this.open());
    }
  }

  draw() {
    this.setFont();

    this.texture?.dispose();

    this.canvas.width = this.ctx.measureText(this._config.content).width + 400;

    this.texture = new CanvasTexture(this.canvas);

    if (this.mesh) {
      this.mesh.scale.set(
        (this.canvas.width / this.canvas.height) * this._config.size * 2,
        this._config.size * 2,
        this._config.size * 2
      );
      if (this._config.position) this.mesh.position.fromArray(this._config.position);
    }
    if (this.material) {
      this.material.uniforms.tMap.value = this.texture;
      this.material.uniforms.uColor.value = new Color(this._config.color);
    }

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.fillStyle = '#000000';
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.fillStyle = '#ffffff';

    this.setFont();

    this.ctx.filter = 'blur(0px)';
    this.ctx.filter = '';
    this.ctx.fillText(this._config.content, 200, 1000);

    this.ctx.globalAlpha = 0.5;
    this.ctx.filter = 'blur(20px)';
    this.ctx.fillText(this._config.content, 200, 1000);

    this.ctx.globalAlpha = 1;

    this.texture.needsUpdate = true;
  }

  open = () => {
    const tl = gsap.timeline();

    tl.to(this.material.uniforms.uProgress, { value: 1, duration: 1, ease: 'power2.out' }, 0);

    return tl;
  };
  close = () => {
    const tl = gsap.timeline();

    tl.to(this.material.uniforms.uProgress, { value: 0, duration: 1, ease: 'power2.out' }, 0);

    return tl;
  };

  createMesh() {
    const geometries = [];
    for (let i = 0; i < 4; i++) {
      const geo = new PlaneGeometry(1, 1);
      geo.translate(0, 0, -i * 0.1);
      geometries.push(geo);
    }
    this.geometry = mergeBufferGeometries(geometries);
    this.material = new TextMaterial(this.app, {
      uniforms: {
        tMap: { value: null },
        uColor: { value: new Color(this._config.color) },
        uProgress: { value: 0 },
        uCoolEffectIntensity: this.app.coolEffectIntensity,
      },
      transparent: true,
      depthWrite: false,
    });

    this.mesh = new Mesh(this.geometry, this.material);
    this.add(this.mesh);
  }

  setFont() {
    if (this._config.fontName) this.ctx.font = `normal 1024px ${this._config.fontName}`;
    else this.ctx.font = `1024px sans-serif`;
  }
}
